import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["buildingId"],
  _excluded2 = ["buildingId", "searchQuery", "includeEmptyUnits", "statuses"],
  _excluded3 = ["buildingId", "searchQuery", "includeEmptyUnits", "statuses", "sortBy", "sortOrder", "page", "pageSize"],
  _excluded4 = ["residencyId"],
  _excluded5 = ["residencyId"],
  _excluded6 = ["residencyId"],
  _excluded7 = ["residencyId"],
  _excluded8 = ["residencyId"],
  _excluded9 = ["residencyId"],
  _excluded0 = ["residencyId"],
  _excluded1 = ["residencyId"],
  _excluded10 = ["residencyId", "residencyAddressId"],
  _excluded11 = ["residencyId", "residencyAddressId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { residenciesRoutes } from './routes';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
export class Residencies {
  constructor() {
    _defineProperty(this, "routes", residenciesRoutes);
  }
  async getAllResidenciesRelatedToSpecificBuilding(data, options) {
    const buildingId = data.buildingId,
      rest = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('property').get(this.routes.residenciesRelatedToSpecificBuilding(buildingId), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async getAllResidenciesRelatedToSpecificBuildingV2(data, options) {
    const buildingId = data.buildingId,
      searchQuery = data.searchQuery,
      includeEmptyUnits = data.includeEmptyUnits,
      statuses = data.statuses,
      rest = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('property').get(
    // NOTE: Backend don't accept query params array like statuses=1,2 for correct work it should get statuses=1&statuses=2
    this.routes.residenciesRelatedToSpecificBuildingV2(buildingId) + '?' + "".concat(statuses !== null && statuses !== void 0 && statuses.length ? statuses.map(n => "statuses=".concat(n)).join('&') + '&' : '') + "searchQuery=".concat(searchQuery, "&") + "includeEmptyUnits=".concat(includeEmptyUnits), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async getAggregateResidencies(data, options) {
    const buildingId = data.buildingId,
      _data$searchQuery = data.searchQuery,
      searchQuery = _data$searchQuery === void 0 ? '' : _data$searchQuery,
      _data$includeEmptyUni = data.includeEmptyUnits,
      includeEmptyUnits = _data$includeEmptyUni === void 0 ? true : _data$includeEmptyUni,
      statuses = data.statuses,
      _data$sortBy = data.sortBy,
      sortBy = _data$sortBy === void 0 ? 'Unitname' : _data$sortBy,
      _data$sortOrder = data.sortOrder,
      sortOrder = _data$sortOrder === void 0 ? 'Asc' : _data$sortOrder,
      page = data.page,
      pageSize = data.pageSize,
      rest = _objectWithoutProperties(data, _excluded3);
    const resp = await requestService('aggregate').get(
    // NOTE: Backend don't accept query params array like statuses=1,2 for correct work it should get statuses=1&statuses=2
    this.routes.aggregateResidencies + '?' + "buildingId=".concat(buildingId) + '&' + "searchQuery=".concat(encodeURIComponent(searchQuery)) + '&' + "includeEmptyUnits=".concat(includeEmptyUnits) + '&' + "sortBy=".concat(sortBy) + '&' + "sortOrder=".concat(sortOrder) + '&' + (!!page ? "page=".concat(page) + '&' : '') + (!!pageSize ? "pageSize=".concat(pageSize) + '&' : '') + "".concat(statuses !== null && statuses !== void 0 && statuses.length ? statuses.map(n => "statuses=".concat(n)).join('&') + '&' : ''), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async searchResidenciesAggregate(data, options) {
    const resp = await requestService(API_SERVICE_NAMES.AGGREGATE).post(this.routes.searchResidenciesAggregate, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createNewResidency(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyResidentsAddendums(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService('property').get(this.routes.addendums(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyResidentsAddendumsV2(data, options) {
    const propertyId = data.propertyId;
    const resp = await requestService('property').get(this.routes.addendumsV2(propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyLeaseDetails(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.leaseDetails(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyLeaseDetails(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded4);
    const resp = await requestService('property').patch(this.routes.leaseDetails(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyOverviewByResidencyId(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.overview(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyNotes(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded5);
    const resp = await requestService('property').put(this.routes.notes(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyNotes(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.notes(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyOccupancy(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.occupancy(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyOccupancy(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded6);
    const resp = await requestService('property').put(this.routes.occupancy(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async batchUpdateResidencyOccupancy(data, options) {
    const resp = await requestService('property').put(this.routes.batchOccupancy, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyBillingSettings(data, options, getIsBillAutomationEnabled) {
    const residencyId = data.residencyId;
    if (getIsBillAutomationEnabled) {
      const resp = await requestService('property').get(this.routes.billingsettings(residencyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    } else {
      const resp = await requestService('property').get(this.routes.billingsettingsLegacy(residencyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    }
  }
  async updateResidencyBillingSettings(data, options, getIsBillAutomationEnabled) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded7);

    // TODO: correct it when endpoint will be ready
    if (getIsBillAutomationEnabled && false) {
      const resp = await requestService('property').put(this.routes.billingsettings(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
      return resp.data;
    } else {
      const resp = await requestService('property').put(this.routes.billingsettingsLegacy(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
      return resp.data;
    }
  }
  async getResidencyMoveOutDate(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.moveOut(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyMoveOutDate(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded8);
    const resp = await requestService('property').put(this.routes.moveOut(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidencyPaperCorrespondenceSetting(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('aggregate').get(this.routes.papercorrespondencesettings(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyPaperCorrespondenceSetting(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded9);
    const resp = await requestService('property').put(this.routes.papercorrespondencesettings(residencyId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async resendPaperInvitation(data, options) {
    const resp = await requestService('property').post(this.routes.resendPaperInvitation(data.residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async resendPaperStatement(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded0);
    const resp = await requestService('property').post(this.routes.resendPaperStatement(residencyId), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async getResidencyAddresses(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').get(this.routes.addresses(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async addResidencyAddress(data, options) {
    const residencyId = data.residencyId,
      rest = _objectWithoutProperties(data, _excluded1);
    const resp = await requestService('property').post(this.routes.addresses(residencyId), _objectSpread(_objectSpread({}, rest), options.cancelToken));
    return resp.data;
  }
  async updateResidencyAddress(data, options) {
    const residencyId = data.residencyId,
      residencyAddressId = data.residencyAddressId,
      rest = _objectWithoutProperties(data, _excluded10);
    const resp = await requestService('property').put(this.routes.updateOrDeleteResidencyAddress(residencyId, residencyAddressId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteResidencyAddress(data, options) {
    const residencyId = data.residencyId,
      residencyAddressId = data.residencyAddressId;
    const resp = await requestService('property').delete(this.routes.updateOrDeleteResidencyAddress(residencyId, residencyAddressId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateResidencyAddressStatus(data, options) {
    const residencyId = data.residencyId,
      residencyAddressId = data.residencyAddressId,
      rest = _objectWithoutProperties(data, _excluded11);
    const resp = await requestService('property').put(this.routes.updateResidencyAddressStatus(residencyId, residencyAddressId), _objectSpread({}, rest), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setAllCustomPrimaryAddressesToSecondary(data, options) {
    const residencyId = data.residencyId;
    const resp = await requestService('property').put(this.routes.disablePrimary(residencyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async batchUpdateBillingSettings(data, options) {
    const resp = await requestService('property').put(this.routes.batchUpdateBillingSettings, [...data.list], _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}